<template>
  <div class="w-100 list-group mb-3  bg-white">
    <div class="py-3 mx-2 d-flex align-content-center justify-content-between border-bottom">
<!--      <div class="fw-bold w-auto my-0 lh-base h5" >我的收藏 (4)</div>-->
      <div class="fw-bold  my-0 lh-base h6" >个人中心 / 我的收藏</div>
    </div>
<!--    <hr class=" my-1 mx-3"/>-->
    <!--没有数据-->
    <NodataCom :show="showNodata"></NodataCom>
    <!--  正在加载-->
    <LoadingCom :show="showLoading"></LoadingCom>
    <!--    列表-->
    <div class="d-flex flex-column  flex-sm-row border-bottom px-2 mx-1 py-2" v-for="(item,index) of list" :key="index">
      <!--     左边-->
      <div class="flex-shrink-0 d-flex align-items-center justify-content-center image-box rounded-3 shadow-sm bg-light" >
<!--          <img src="../../assets/images/testImag.png" class="image-width" alt="">-->
        <img  :src="item.MainImage" class="image-width" alt="" >
        </div>
      <!--     右边-->
      <div class="flex-fill px-3 ">
          <div class="d-flex align-items-center justify-content-between mt-1">
            <div class="pub-one-row-flex fw-bold  title-left  pub-word-breakAll me-3 flex-1 width-0">
              预约设备：{{item.Name || "未知"}}
            </div>
            <button type="button" class="btn btn-link text-decoration-none fw-bold btn-sm small-btn-size" @click="quiteAction(item)" >取消收藏</button>
          </div>
        <div class="d-flex flex-wrap mt-4">
          <div class="list-item-des mb-2">
            <small class="small me-3 text-body-secondary pub-word-breakAll">型号：{{item.Model || "未知"}} </small>
          </div>
          <div class="list-item-des mb-2">
            <small class="small me-3 text-body-secondary pub-word-breakAll">厂家：{{item.Manufacturer || "未知"}} </small>
          </div>
          <div class="list-item-des mb-2">
            <small class="small me-3 text-body-secondary pub-word-breakAll">所属：{{item.InstitutionName || "未知"}} </small>
          </div>
          <div class="list-item-des mb-2">
            <small class="small me-3 col-md text-body-secondary pub-word-breakAll">位置：{{item.Address || "未知"}} </small>
          </div>
        </div>
        </div>
    </div>

  </div>

  <PaginationCom
      @pageChange="pageChangeFun($event)"
      :totalIn="total"
      :currentIn="params.current"
      :pageSizeIn="params.pageSize"
  ></PaginationCom>
<!--  &lt;!&ndash;没有数据&ndash;&gt;-->
<!--  <NodataCom :show="showNodata"></NodataCom>-->
<!--  &lt;!&ndash;  正在加载&ndash;&gt;-->
<!--  <LoadingCom :show="showLoading"></LoadingCom>-->
  <!--  撤销收藏-->
  <div class="modal fade" ref="quitModel" id="quitModel" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title fw-bold" id="exampleModalToggleLabel2">取消收藏</div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          确定要取消收藏吗?
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="callbackState">取消</button>
          <button type="button" class="btn btn-primary" :disabled="callbackState" @click="quite">
            <div class="spinner-border spinner-border-sm" role="status" v-if="callbackState">
              <span class="visually-hidden">Loading...</span>
            </div>
            确定
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import NodataCom from "@/layout/NodataCom"
import LoadingCom from "@/layout/LoadingCom"
import {onMounted, reactive, ref} from "vue";
import {myCollectDevices,uncollectDevice} from "@/api/device";
import {formatTime} from "@/utils/dateFun";
import {showToast} from "@/utils/toast";
import {defaultImage} from "@/utils/commonSetting";

import {Modal} from "bootstrap";
const params = reactive({
  current:1,
  pageSize:10,
})

const total  = ref(0)
const list = ref([])
const showNodata = ref(false)
const showLoading = ref(false)
const callbackState = ref(false);
let quitModelRef = "" // 取消模态框 实例
const quitModel = ref() // 取消模态框 dom
let choisedItem = ""; // 被选中的要操作的
onMounted(()=>{
  getList(true)
})
const showModel = ()=>{
  if(!quitModelRef){
    quitModelRef = new Modal(quitModel.value);
  }
  quitModelRef.show();
}

const hideModel = ()=>{
  if(!quitModelRef){
    quitModelRef = new Modal(quitModel.value);
  }
  quitModelRef.hide();
}
// 取消收藏
const quiteAction =  (item)=>{
  showModel()
  choisedItem = item
  callbackState.value = false
}
const quite = async ()=>{
  callbackState.value = true
  const res = await uncollectDevice({id:choisedItem.ID})
  callbackState.value = false
  if(res.err_code==0){
    // 判断是否要重新请求数据
    const index = list.value.findIndex(item => item.ID === choisedItem.ID);
    console.log(index)
    if(index > -1){
      list.value.splice(index, 1); // 删除找到的元素
      console.log(list.value)
      total.value = total.value -1
    }
    if(list.value.length<=0){
    await  getList(true)
    }

    hideModel()
    return showToast("success","取消收藏成功")
  }else{
    return showToast("danger",res.err_msg || "请求出错")
  }
}
const pageChangeFun = (e)=>{
  params.current = e.page
  params.pageSize = e.pageSize
  getList()
}
// 获取消息列表
const getList = async (currentinit)=>{
  if(currentinit){
    params.current = 1
  }
  showLoading.value = true
  showNodata.value = false
  list.value = []
  total.value = 0
  const res =await myCollectDevices(params)
  showLoading.value = false
  if(res.err_code==0){
    const data =  res.data || []
    data.forEach(item=>{
      if(item.CreatedAt){
        item.CreatedAtdeal = formatTime(item.CreatedAt)
      }
      if(item.Institution){
        item.InstitutionName = item.Institution.Name
      }
      if(!item.MainImage){
        item.MainImage = defaultImage
      }
    })
    list.value = data
    total.value = res.count || 0
    if(data.length<=0){
      showNodata.value = true
    }
  }else{
    showToast("danger",res.err_msg || "请求出错")
  }
}

</script>

<style scoped lang="scss">

.title-left{
  word-break: break-all;
}
.title-badge{
  height: 1.5rem;
  line-height: 1rem;
  font-size: 0.7rem;
  font-weight: normal;
}
.small{
  font-size: 0.9rem;
}
.list-box{
  box-sizing: border-box;
}

.small-btn-size{
  height: 1.5rem;
  line-height: 1rem;
}

.btn-check + .btn{
  border: none;
}
.btn-check:checked + .btn{
  color: #0d6efd;
}
//.image-box{
//  width: 100%;
//  min-width: 160px;
//  background: #f6f7f8;
//  padding: 1px;
//
//  @media (min-width: 576px){
//    width: 120px;
//  }
//}
.image-width{
  width: 300px;
  height: 190px; //100%
  //max-height: 120px;
  object-fit: cover; /* 保持图片比例且填满容器 */
  @media (min-width: 576px){
    width: 150px;
    height: 95px; //100%
  }
}
.list-item-des{
  width: 100%;
  @media (min-width: 927px){
    width: 50%;
  }
}

</style>
